var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_167063",
    "data-name": "Group 167063",
    transform: "translate(295 440) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3232",
    "data-name": "Path 3232",
    d: "M1164,1235.48l7,7,7-7",
    transform: "translate(-955.98 1599) rotate(-90)",
    fill: "none",
    stroke: "#636974",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackIcon);
export default __webpack_public_path__ + "static/media/arrowBack_icon.8e3f5272378725b598b2515f37b6290e.svg";
export { ForwardRef as ReactComponent };